import type { IconProps } from '.';

/**
 * Instagram Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const InstagramIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    width="22"
    height="22"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.84766 0.00195312C3.98866 0.00195312 0.849609 3.14391 0.849609 7.00391V17.0039C0.849609 20.8629 3.99156 24.002 7.85156 24.002H17.8516C21.7106 24.002 24.8496 20.86 24.8496 17V7C24.8496 3.141 21.7077 0.00195312 17.8477 0.00195312H7.84766ZM19.8496 4.00195C20.4016 4.00195 20.8496 4.44995 20.8496 5.00195C20.8496 5.55395 20.4016 6.00195 19.8496 6.00195C19.2976 6.00195 18.8496 5.55395 18.8496 5.00195C18.8496 4.44995 19.2976 4.00195 19.8496 4.00195ZM12.8496 6.00195C16.1586 6.00195 18.8496 8.69295 18.8496 12.002C18.8496 15.311 16.1586 18.002 12.8496 18.002C9.54061 18.002 6.84961 15.311 6.84961 12.002C6.84961 8.69295 9.54061 6.00195 12.8496 6.00195ZM12.8496 8.00195C11.7887 8.00195 10.7713 8.42338 10.0212 9.17353C9.27104 9.92367 8.84961 10.9411 8.84961 12.002C8.84961 13.0628 9.27104 14.0802 10.0212 14.8304C10.7713 15.5805 11.7887 16.002 12.8496 16.002C13.9105 16.002 14.9279 15.5805 15.678 14.8304C16.4282 14.0802 16.8496 13.0628 16.8496 12.002C16.8496 10.9411 16.4282 9.92367 15.678 9.17353C14.9279 8.42338 13.9105 8.00195 12.8496 8.00195Z"
      fill="white"
    />
  </svg>
);

export default InstagramIcon;
